module.exports = __webpack_public_path__ + "static/media/action-btn-bg.81a09dd9.png";